import api from '@/services/api/api';

export const useCollectionSlug = (slug) => {
  const collectionSlug = useQuery(
    ['collectionSlug', slug],
    async () => {
      const { data } = await api.collections.getCollectionBySlug(slug);
      return data;
    },
    {
      enabled: computed(() => !!slug),
      staleTime: Infinity,
      select: (data) => ({
        highlight: data?.highlight,
        image: data?.image,
      }),
    },
  );

  onServerPrefetch(async () => {
    await collectionSlug.suspense();
  });

  return {
    collectionSlug,
  };
};
